import { Button, Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import { useCompleteCounsellingRequestMutation } from "../../../../../../services/counselling-service";

const CompleteRequest = ({ request, show, onClose, refetch }) => {
  const [completeRequest] = useCompleteCounsellingRequestMutation();

  const handleRequestCompletion = async () => {
    try {
      const response = await completeRequest(request?.id).unwrap();
      const { code, message } = response!;
      console.log("Upload successful", response);
      if (code === 0) {
        toast.success(message);
        onClose();
        refetch();
      } else {
        toast.error(message || "Something went wrong");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      toast.error(error?.data?.message);
    }
  };

  return (
    <>
      <Modal show={show} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title className="fs-6">Complete Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you want to complete {request?.requestType} counselling with{" "}
            {request?.requestedBy?.map((item, index) => (
              <span key={index}>
                {item.firstName} {item.lastName}
              </span>
            ))}
            ,{" "}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="dark"
            className="users-text rounded-5"
            onClick={onClose}
          >
            Close
          </Button>
          <Button
            className="users-text rounded-5"
            variant="success"
            onClick={handleRequestCompletion}
          >
            Complete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CompleteRequest;
